var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeTileGoodOldDaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "89px",
    viewBox: "0 0 113 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.72385268,0.13 C3.61462786,0.13 0.2825,3.47130727 0.2825,7.59185227 L0.2825,7.59185227 L0.2825,80.8081477 C0.2825,84.9286927 3.61462786,88.27 7.72385268,88.27 L7.72385268,88.27 L104.711147,88.27 C108.820372,88.27 112.1525,84.9286927 112.1525,80.8081477 L112.1525,80.8081477 L112.1525,7.59185227 C112.1525,3.47130727 108.820372,0.13 104.711147,0.13 L104.711147,0.13 L7.72385268,0.13 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop---Good-Old-Daze",
    transform: "translate(-36.000000, -33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(36.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#02475F",
    mask: "url(#mask-2)",
    points: "68.0825 92.79 90.6825 92.79 90.6825 -17.95 68.0825 -17.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#E96B24",
    mask: "url(#mask-2)",
    points: "37.5725 92.79 80.5125 92.79 80.5125 -17.95 37.5725 -17.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#0097A2",
    mask: "url(#mask-2)",
    points: "0.2825 92.79 56.7825 92.79 56.7825 -1 0.2825 -1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#5EB56C",
    mask: "url(#mask-2)",
    points: "89.5525 92.79 112.1525 92.79 112.1525 -17.95 89.5525 -17.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4914316,48.72 L14.7035684,48.72 C13.6044987,48.72 12.7125,47.70752 12.7125,46.46 C12.7125,45.21248 13.6044987,44.2 14.7035684,44.2 L43.4914316,44.2 C44.5905013,44.2 45.4825,45.21248 45.4825,46.46 C45.4825,47.70752 44.5905013,48.72 43.4914316,48.72",
    id: "Fill-37",
    fill: "#FEFEFE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2257009,58.89 L14.6692991,58.89 C13.5881676,58.89 12.7125,57.87752 12.7125,56.63 C12.7125,55.38248 13.5881676,54.37 14.6692991,54.37 L32.2257009,54.37 C33.305854,54.37 34.1825,55.38248 34.1825,56.63 C34.1825,57.87752 33.305854,58.89 32.2257009,58.89",
    id: "Fill-39",
    fill: "#FEFEFE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.616633,29.51 L16.5773739,29.51 C14.4423588,29.51 12.7125,27.7602578 12.7125,25.5996978 L12.7125,15.3403022 C12.7125,13.1797422 14.4423588,11.43 16.5773739,11.43 L41.616633,11.43 C43.7516482,11.43 45.4825,13.1797422 45.4825,15.3403022 L45.4825,25.5996978 C45.4825,27.7602578 43.7516482,29.51 41.616633,29.51",
    id: "Fill-41",
    fill: "#FEFEFE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.711147,88.27 L7.72385268,88.27 C3.61462786,88.27 0.2825,84.9286927 0.2825,80.8081477 L0.2825,7.59185227 C0.2825,3.47130727 3.61462786,0.13 7.72385268,0.13 L104.711147,0.13 C108.820372,0.13 112.1525,3.47130727 112.1525,7.59185227 L112.1525,80.8081477 C112.1525,84.9286927 108.820372,88.27 104.711147,88.27 Z",
    id: "Stroke-43",
    stroke: "#8D8F92",
    strokeWidth: 0.5,
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeTileGoodOldDaze);
export default __webpack_public_path__ + "static/media/themeTile_GoodOldDaze.e19224921fe9961681f18bb76b8e3de6.svg";
export { ForwardRef as ReactComponent };